import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSync = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M16.063 3.662c.38 0 .687.307.687.687v2.77c0 .38-.308.688-.688.688H13.3a.688.688 0 0 1 0-1.375h2.075V4.35c0-.38.308-.687.688-.687Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M10.723 4.44a5.5 5.5 0 0 0-6.348 5.43A.688.688 0 0 1 3 9.869 6.875 6.875 0 0 1 14.458 4.75l.002.001 2.062 1.856a.688.688 0 0 1-.92 1.022l-2.06-1.854-.001-.001a5.5 5.5 0 0 0-2.818-1.334M3 12.62c0-.38.308-.688.688-.688H6.45a.688.688 0 0 1 0 1.375H4.375v2.073a.687.687 0 1 1-1.375 0z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M16.063 9.182c.38 0 .687.309.687.688a6.875 6.875 0 0 1-11.458 5.118l-.002-.001-2.062-1.856a.687.687 0 1 1 .92-1.022l2.06 1.854.001.001a5.5 5.5 0 0 0 9.166-4.095c0-.38.308-.687.688-.687"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSync;
